<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="450px"
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        color="primary"
        v-on="on"
      >
        <v-icon>
          mdi-pencil
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Type of Misconduct"
      text="Edit Type of Misconduct"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="localTypeOfMisconduct.code"
                v-validate="'required'"
                :error-messages="errors.collect('code')"
                data-vv-name="code"        
                outlined        
                data-vv-as="type of misconduct code"                  
                label="Type of Misconduct Code"
              />
            </v-col>

            <v-col
              v-if="typeOfMisconductRevisions.length > 0"
              cols="12"
            >
              <v-autocomplete
                v-model="localTypeOfMisconduct.type_of_misconduct_revision_id"
                v-validate="'required'"
                :error-messages="errors.collect('version')"
                data-vv-name="version"  
                :items="typeOfMisconductRevisions"
                label="Version"
                item-text="name"
                item-value="id"
                outlined
              />
            </v-col>

            <v-col cols="12">
              <v-autocomplete
                v-model="localTypeOfMisconduct.job_group_policy_id"
                :items="jobGroupPolicies"
                label="Disciplinary Group"
                item-text="name"
                item-value="id"
                outlined
                clearable
              />
            </v-col>

            <v-col cols="12">
              <tiptap-vuetify
                v-model="localTypeOfMisconduct.name"
                v-validate="'required'"
                :extensions="extensions"
                class="full-width text-editor-toolbar-height pb-1"
                :error-messages="errors.collect('name')"
                data-vv-name="name"
                data-vv-as="type of misconduct"
                placeholder="Type of Misconduct"
              />
            </v-col>
          </v-row>
        </v-container>
      </form>

      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10" 
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary" 
          class="white--text px-10"         
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { TiptapVuetify, Heading, Bold, Italic, Underline, BulletList, OrderedList, ListItem, Link, HardBreak } from 'tiptap-vuetify'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      TiptapVuetify,
    },
    props: {
      typeOfMisconduct: {
        type: Object,
        default: null,
      },  
      jobGroupPolicies: {
        type: Array,
        default: null,
      },
      typeOfMisconductRevisions: {
        type: Array,
        default: null,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        localTypeOfMisconduct: null,
        extensions: [
          Link,
          Underline,
          Italic,
          ListItem,
          BulletList,
          OrderedList,
          [Heading, {
            options: {
              levels: [1, 2, 3],
            },
          }],
          Bold,
          HardBreak,
        ],
      }
    },
    watch: {
      dialog: function (value) {
        if (!value) return

        this.localTypeOfMisconduct = { ...this.typeOfMisconduct }
        
        this.$validator.extend('codeFormat', {
          getMessage (field, args) {
            return 'Invalid code. Only numbers and . allowed; not allowing two consecutive special characters; not allowing start and end with special character'
          },
          validate (value, args) {
            const regex = /^(?![-_.])(?!.*[-_.]{2})(?!.*[-_.]$)[0-9.]*$/
            return regex.test(value)
          },
        })
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.typeOfMisconducts().update(this.typeOfMisconduct.id, this.prepareFormData())
              .then(response => {
                if (response.status >= 200 && response.status < 300) {
                  this.$emit('updated')
                  this.$snack({ message: response.data.status })

                  this.dialog = false
                }
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.message, 
                  })
                } else {
                  this.$snack({ color: 'error', message: 'Unable to create type of misconduct' })
                }
              })
              .then(() => {
                this.progressing = false
              })
          })
      },
      prepareFormData () {
        if (this.localTypeOfMisconduct.name.startsWith('<p>') && this.localTypeOfMisconduct.name.endsWith('</p>')) {
          const removeLeadingtag = this.localTypeOfMisconduct.name.substring(3)
          this.localTypeOfMisconduct.name = removeLeadingtag.slice(0, -4)
        }
        
        return {
          name: this.localTypeOfMisconduct.name,
          code: this.localTypeOfMisconduct.code,
          type_of_misconduct_revision_id: this.localTypeOfMisconduct.type_of_misconduct_revision_id,
          job_group_policy_id: (this.localTypeOfMisconduct.job_group_policy_id === 'undefined' || this.localTypeOfMisconduct.job_group_policy_id === 'null') ? null : this.localTypeOfMisconduct.job_group_policy_id,
        }
      }, 
    },
  }
</script>

<style scoped>
.text-editor-toolbar-height>>> .v-toolbar__content{
  height: unset !important;
  min-height: 42px;
}
.text-editor-toolbar-height>>>.v-sheet.v-sheet--tile.theme--light.v-toolbar.v-toolbar--dense.v-toolbar--flat.grey.lighten-4{
  min-height:unset !important;
}

 .full-width{
   width: 100%;
 }
</style>
